import React, {useState} from 'react'
import SkeletonLoader from '../skeleton-loader'
import {ParagraphText, Button, Icon} from '@thryvlabs/maverick'
import {usePaymentCheckboxes} from './contexts/payment-checkboxes-context'

import {MainMobileContainer} from '../ui/payment-information'
import {PaymentForm} from './recurly-payment-form'
import {AchPaymentForm} from './ach-payment-form'
import {BecsPaymentForm} from './becs-payment-form'
import {InvoicePaymentForm} from './invoice-payment-form'
import {BillingNoticeModal} from '../../components/billing-notice-modal'
import {usePaymentOrder} from './hooks/use-payment-order'
import ExpiryCountdownTimer from '../expiry-countdown-timer'
import {MC_2_0_PLANS, GST_MULTIPLIERS} from '../../utils/constants'
import logo from '../../assets/thryv-logo-white-letters.svg'
import achWarningIcon from '../../assets/ach-warning-icon.svg'
import keapLogo from '../../assets/proposal-tool/keap-white.png'
import {formatPrice} from '../../utils/currency-format'
import {calculateCouponsAmountForItem} from '../../utils/coupon-helpers'
import {GradientTabs, GradientTab} from '../../core/shared/GradientTabs'
import {CCDesktopTodaySummary} from './cc-desktop-today-summary'
import {CCDesktopMonthlySummary} from './cc-desktop-monthly-summary'
import {getTodayPreviewItems} from '../../utils/get-today-preview-items'
import {useFlags} from 'launchdarkly-react-client-sdk'
import {ONE_TIME_FEES, KEEP_THRYV_PREFIX_PRODUCT_CODES} from './constants'
import {PaymentMethod} from './payment-method'
import '../../styles/formScreensStyles.css'
import {toast} from 'react-toastify'
export function MobilePaymentHeader({
  paymentState,
  linkExpiryInMilliSec,
  currentStep,
  onBack,
}) {
  const businessName =
    paymentState.paymentInfo?.businessAddress?.company ||
    paymentState.paymentInfo?.company
  const country = paymentState.paymentInfo?.country
  const isAusNZ = ['AU', 'NZ'].includes(country)

  const {
    monthlyAmount,
    monthlyTodayAmount,
    oneTimeTodayAmount,
    annualTodayAmount,
    semiAnnuallyAmount,
    oneTimeAmount,
    annualAmount,
    totalPaymentAmount,
  } = paymentState
  const formattedOneTimeAmount = oneTimeAmount !== undefined ? oneTimeAmount : 0
  const formattedAnnualAmount = annualAmount !== undefined ? annualAmount : 0
  const monthlyTotalDue =
    (oneTimeTodayAmount ?? formattedOneTimeAmount) +
    (monthlyTodayAmount ?? monthlyAmount) +
    (annualTodayAmount ?? formattedAnnualAmount)
  const semiAnnuallyTotalDue = oneTimeAmount + semiAnnuallyAmount
  const totalNoTaxes =
    semiAnnuallyAmount > 0 ? semiAnnuallyTotalDue : monthlyTotalDue
  const total =
    totalPaymentAmount > 0 ? totalPaymentAmount : Math.max(totalNoTaxes, 0)
  const totalFormatted = total > 0 ? formatPrice(total, 1, '', country) : ''
  const hasTax = paymentState.calculatedTaxes === null && !isAusNZ

  return (
    <header
      style={{
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        padding: '0px',
        paddingTop: '26px',
      }}
    >
      {/* Row 1a: logos */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
          alignItems: 'center',
          marginBlock: '8px',
        }}
      >
        <div
          style={{
            display: 'flex',
          }}
        >
          {currentStep > 1 && currentStep < 5 && onBack && (
            <button type="button" onClick={onBack} className="mobile-back-btn">
              <svg
                width="17"
                height="9"
                viewBox="0 0 17 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.63509 8.02841C3.63396 8.02729 3.63285 8.02616 3.63173 8.02502L0.160293 4.529C0.132896 4.50123 0.108562 4.47053 0.0876954 4.43748L0.0332415 4.33681L0.0105453 4.26817L0.0105453 4.21783C-0.00351486 4.1407 -0.00351486 4.06161 0.0105453 3.98446L0.0105453 3.93871L0.0105453 3.88379L0.0513857 3.80599C0.0747413 3.76265 0.103734 3.72262 0.137597 3.68701L3.63173 0.177268C3.86294 -0.057757 4.23933 -0.0592799 4.4724 0.173879C4.47353 0.174995 4.47463 0.176132 4.47576 0.177268C4.69992 0.414181 4.69992 0.786893 4.47576 1.02383L2.40652 3.11503C2.31879 3.20525 2.3202 3.35012 2.40968 3.43858C2.45131 3.47974 2.50704 3.50317 2.56535 3.50398L16.4055 3.50398C16.7338 3.50396 17 3.77232 17 4.1034C17 4.43447 16.7339 4.70285 16.4056 4.7029L2.56535 4.7029C2.44006 4.70468 2.33989 4.80854 2.34166 4.93488C2.34249 4.99365 2.3657 5.04987 2.40652 5.09185L4.47576 7.17391C4.70281 7.41143 4.70281 7.78753 4.47576 8.02504C4.24455 8.26007 3.86816 8.26159 3.63509 8.02841Z"
                  fill="white"
                />
              </svg>{' '}
              Back
            </button>
          )}
          <img
            src={logo}
            style={{marginLeft: 'auto'}}
            alt="Thryv Logo"
            className="header-logo"
          />
        </div>

        {/* SEPARATOR */}
        <div
          style={{
            height: '36px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            marginInline: '10px',
            flexShrink: 0,
          }}
        />

        <div style={{display: 'flex', alignItems: 'center'}}>
          <img src={keapLogo} alt="Keap Logo" className="header-logo" />
        </div>
      </div>

      {/* Row 1b: business name | timer */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
          alignItems: 'flex-start',
          paddingBottom: '10px',
        }}
      >
        <div style={{display: 'flex', flexDirection: 'column'}}>
          {businessName && (
            <>
              <span className="payment-header-label">
                You&apos;re paying for
              </span>
              <span className="payment-header-value">{businessName}</span>
            </>
          )}
        </div>

        {/* SEPARATOR */}
        <div
          style={{
            height: '57px',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            marginInline: '10px',
            flexShrink: 0,
          }}
        />

        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
          {linkExpiryInMilliSec > 0 && (
            <ExpiryCountdownTimer
              countdownTimeMS={linkExpiryInMilliSec}
              isHourlyNeeded={linkExpiryInMilliSec > 60 * 60 * 1000}
              isMobileView={true}
            />
          )}
        </div>
      </div>

      {currentStep === 1 && (
        <>
          {/* Horizontal separator */}
          <div
            style={{
              border: '1px solid rgba(255, 255, 255, 0.1)',
              marginInline: '-10px',
            }}
          />

          {/* Row 2: Order Summary | Total */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '5fr 1fr',
              alignItems: 'center',
              paddingBlock: '10px',
              gap: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingRight: '35px',
              }}
            >
              <span
                className="payment-header-value"
                style={{
                  fontSize: '18px',
                  lineHeight: '100%',
                  letterSpacing: '0%',
                }}
              >
                Order Summary
              </span>
              <span className="payment-header-note" style={{marginTop: '10px'}}>
                Future invoices will include any eligible discount for as long
                as your account qualifies.
              </span>
            </div>
            <div className="payment-total-container">
              {totalFormatted && (
                <>
                  <p className="payment-total-label">Total</p>
                  <p className="payment-total-amount">
                    {totalFormatted}
                    {hasTax && (
                      <span className="payment-total-label"> + tax</span>
                    )}
                  </p>
                </>
              )}
            </div>
          </div>
        </>
      )}
    </header>
  )
}

const TOTAL_STEPS = 5

const StepContainer = ({
  title,
  children,
  nextStep,
  prevStep,
  continueButtonText,
  showContinueButton = true,
  disableContinueButton = false,
}) => {
  return (
    <div className="step__container">
      {title && (
        <div className="d-flex align-items-center">
          {typeof prevStep === 'function' && (
            <Icon
              type="solid"
              variant="chevronLeft"
              className="mr-4"
              onClick={prevStep}
            />
          )}
          <ParagraphText variant="lg" className="font-weight-bold mb-0">
            {title}
          </ParagraphText>
        </div>
      )}
      <div className="d-flex justify-content-center align-items-center">
        {children}
      </div>
      {showContinueButton && (
        <div className="d-flex justify-content-center align-items-center">
          <Button
            variant="primary"
            type="button"
            className="step__container__button"
            onClick={nextStep}
            disabled={disableContinueButton}
          >
            {continueButtonText || 'Continue'}
          </Button>
        </div>
      )}
    </div>
  )
}

const MobileLayout = ({
  paymentState,
  isLoading,
  calculateTaxes,
  calculatingTaxes,
  setCalculatingTaxes,
  handleChangePaymentMethod,
  paymentMethods,
  savePaymentContinue,
  uuid,
  paymentRequestState,
  isAddressUpdated,
  setIsAddressUpdated,
  updateParentAddress,
  setPaymentRequestState,
  currentStep,
  setCurrentStep,
  linkExpiryInMilliSec,
  handleProcessPurchase,
}) => {
  const {is5Order} = usePaymentOrder()
  const [name, setName] = React.useState('')
  const {checkBoxesValues, setCheckBoxesValues, isAgreeCheckboxDisabled} =
    usePaymentCheckboxes()
  console.log('[MobileLayout] currentStep:', currentStep)

  const [addressInformation, setAddressInformation] = React.useState({
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    postalCode: '',
    state: '',
  })
  // const cardDetails = useRef({})
  const [isBillingNoticeDisplayed, setIsBillingNoticeDisplayed] =
    React.useState(false)
  console.log(
    'isBillingNoticeDisplayed from old-flow-desktop:: ',
    isBillingNoticeDisplayed,
  )
  const isAusNZ = ['AU', 'NZ'].includes(paymentState.paymentInfo?.country)

  const paymentPreview = paymentState.paymentInfo?.paymentPreview
  const locationPreviews = paymentState.paymentInfo?.locationPreviews
  const isSEOPreviewAvailable = paymentPreview?.apps?.find(({planCode}) =>
    ['seo-5-thryv-m2m', 'seombg-5-thryv-m2m'].includes(planCode),
  )
  console.log(isSEOPreviewAvailable)

  const {frontendPreviewPayment} = useFlags()
  const [activeTab, setActiveTab] = useState('today')
  const [isPaymentMethodLoading, setIsPaymentMethodLoading] = useState(false)
  const [hasEnteredStep2, setHasEnteredStep2] = React.useState(false)
  const [couponDiscountAmount, setCouponDiscountAmount] = React.useState(0)
  const couponDiscountAmountRef = React.useRef(0)
  React.useEffect(() => {
    if (couponDiscountAmountRef.current !== couponDiscountAmount) {
      setCouponDiscountAmount(couponDiscountAmountRef.current)
    }
  }, [couponDiscountAmount])

  const country = paymentState.paymentInfo?.country
  const isAu = country === 'AU'
  const {
    monthlyAmount,
    annualAmount,
    semiAnnuallyAmount,
    annualAddons,
    semiAnnuallyAddons,
    monthlyAddons,
    oneTimeAddons,
    totalPaymentAmount,
    monthlyTodayAmount,
    oneTimeTodayAmount,
    annualTodayAmount,
    oneTimeAmount,
  } = paymentState

  const subscriptionDisclaimerText = [
    ...(monthlyAddons || []),
    ...(annualAddons || []),
  ].some(({code}) => MC_2_0_PLANS.includes(code))
    ? 'Your Thryv Software Subscription Period is month-to-month, or 12 months if you choose an annual plan. Add-on Subscription Services have a 6-month initial term unless stated otherwise in their product-specific terms. Some Subscription Services also carry a per-user fee that varies by user count, where applicable.'
    : '*Unless noted as annual (12 months) on this page, the Subscription Period is 6 months. Please note, certain Thryv Services contain an additional per user fee which will vary based on the number of applicable users/employees/contractors.'

  const todayItems = []
  if (annualAmount > 0) todayItems.push(...annualAddons)
  if (semiAnnuallyAmount > 0) todayItems.push(...semiAnnuallyAddons)
  else todayItems.push(...monthlyAddons)
  todayItems.push(...oneTimeAddons)

  const isAnnualPlanIncluded = annualAmount > 0 && monthlyAmount === 0
  const summaryMonthlyAddons = isAnnualPlanIncluded
    ? annualAddons
    : monthlyAddons
  const summaryMonthlyLabel = isAnnualPlanIncluded
    ? 'Due Annually'
    : 'Due Monthly'
  const monthlyTabAmount = isAnnualPlanIncluded ? annualAmount : monthlyAmount

  const formattedOneTimeAmount = oneTimeAmount !== undefined ? oneTimeAmount : 0
  const formattedAnnualAmount = annualAmount !== undefined ? annualAmount : 0
  const monthlyTotalDue =
    (oneTimeTodayAmount ?? formattedOneTimeAmount) +
    (monthlyTodayAmount ?? monthlyAmount) +
    (annualTodayAmount ?? formattedAnnualAmount)
  const semiAnnuallyTotalDue = oneTimeAmount + semiAnnuallyAmount
  const totalNoTaxes =
    semiAnnuallyAmount > 0 ? semiAnnuallyTotalDue : monthlyTotalDue
  const todayTotal =
    frontendPreviewPayment && locationPreviews
      ? Math.max(
          Object.values(locationPreviews).reduce(
            (sum, lp) => sum + (lp.total ?? 0),
            0,
          ) +
            (paymentState?.paymentInfo?.balanceInfo?.availableCreditAmount ||
              0),
          0,
        )
      : frontendPreviewPayment && paymentPreview
      ? Math.max(
          paymentPreview.total +
            (paymentState?.paymentInfo?.balanceInfo?.availableCreditAmount ||
              0),
          0,
        )
      : totalPaymentAmount > 0
      ? totalPaymentAmount
      : Math.max(totalNoTaxes - couponDiscountAmount, 0)

  const supportFee = monthlyAddons?.find(({code}) => code === '247support-m2m')
  const hasSupportFee =
    !frontendPreviewPayment || !paymentPreview
      ? monthlyAddons?.some(({code}) => code === '247support-m2m')
      : paymentPreview.apps?.some(({planCode}) => planCode === '247support-m2m')

  const COMMAND_CENTER_NAME_MAPPING = {
    'cc_basic-5-thryv-m2m': 'My Account',
    'cc_basicpls-5-thryv-m2m': 'My Account',
    'cc_plus-5-thryv-m2m': 'My Account Plus',
    'cc_pro-5-thryv-m2m': 'My Account Pro',
  }

  let listOfCouponsUsed = []
  const getProducts = (items, includeCoupons = false) => {
    const nestedAddonCodesBase = new Set(
      items.flatMap(item =>
        (item.addons || [])
          .filter(a => a.prodType === 'itemBasedAddon')
          .map(a => a.code),
      ),
    )
    if (!includeCoupons) {
      return items.filter(item => !nestedAddonCodesBase.has(item.code))
    }
    let itemsCouponDiscountAmount = 0
    items = items.flatMap(current => {
      if (nestedAddonCodesBase.has(current.code)) return []
      if (current.code?.startsWith('cc_')) {
        current.name = COMMAND_CENTER_NAME_MAPPING[current.code]
      } else if (current.code?.startsWith('mc_')) {
        if (
          current.name.startsWith('Thryv') &&
          !KEEP_THRYV_PREFIX_PRODUCT_CODES.includes(current.code)
        ) {
          current.name = current.name.replace('Thryv', '')
        }
      } else if (
        current.code?.includes('addon-5-keap-addons') ||
        current.code?.includes('addon-5-keap-addons-annual') ||
        current.code?.startsWith('vert_') ||
        current.code?.startsWith('max')
      ) {
        if (
          current.name.startsWith('Thryv') &&
          !KEEP_THRYV_PREFIX_PRODUCT_CODES.includes(current.code)
        ) {
          current.name = current.name.replace('Thryv', '')
        }
      }
      const currentPrice = Number(current?.currency?.unitAmount || 0)
      const isCohort = paymentState?.paymentInfo?.isCohort
      if (!isCohort && currentPrice > 0 && !current.isExisting) {
        let price = 0
        let couponUsed = null
        const effectivePreview =
          locationPreviews?.[current.locationThryvId] ?? paymentPreview

        if (effectivePreview) {
          price = current.discount || 0
          if (price > 0 && paymentState?.paymentInfo?.coupons) {
            const calculatedAmount = calculateCouponsAmountForItem(
              current,
              paymentState.paymentInfo.coupons,
            )
            couponUsed = calculatedAmount.coupon
          }
        } else if (paymentState?.paymentInfo?.coupons) {
          const calculatedAmount = calculateCouponsAmountForItem(
            current,
            paymentState.paymentInfo.coupons,
          )
          couponUsed = calculatedAmount.coupon
          const currentCouponWaivedAmount = calculatedAmount.discountAmount
          price = currentCouponWaivedAmount
          itemsCouponDiscountAmount += currentCouponWaivedAmount
        }
        if (price > 0) {
          if (couponUsed) {
            listOfCouponsUsed.push({
              name: couponUsed?.name,
              description: couponUsed?.description,
              code: couponUsed.code,
              isCouponName: true,
              isCoupon: true,
              locationThryvId: current.locationThryvId,
            })
          }
          const isOneTimeFee = ONE_TIME_FEES.some(fee =>
            current?.name?.toLowerCase().includes(fee),
          )
          const gstMultiplier = isOneTimeFee
            ? GST_MULTIPLIERS[paymentState?.paymentInfo?.country] ?? 1
            : 1
          return [
            current,
            {
              name: couponUsed?.name || 'Incentive',
              currency: {unitAmount: price * gstMultiplier * -1},
              isIncentive: true,
              isDiscount: couponUsed?.type === 'percent',
              appliedTo: current.code,
              sorting: current.name,
              locationThryvId: current.locationThryvId,
            },
          ]
        }
      }
      return current
    })
    listOfCouponsUsed = listOfCouponsUsed.filter(
      (item, index, self) =>
        index === self.findIndex(t => t.code === item.code),
    )
    couponDiscountAmountRef.current = itemsCouponDiscountAmount
    return [...items, ...listOfCouponsUsed]
  }

  const nextStep = () => {
    let _currentStep = currentStep
    if (currentStep >= TOTAL_STEPS - 1) {
      _currentStep = TOTAL_STEPS
    } else {
      _currentStep = currentStep + 1
    }
    setCurrentStep(_currentStep)
  }

  const handleSubmitOrder = () => {
    savePaymentContinue()
    setIsAddressUpdated(true)
    if (
      paymentState.paymentInfo.isInvoiceBilled &&
      paymentState?.paymentMethod?.value === 'invoice' &&
      !isAusNZ
    ) {
      setCurrentStep(5)
    } else {
      handleProcessPurchase()
    }
  }

  // React.useEffect(() => {
  //   if (paymentRequestState.requested && !paymentRequestState.hasErrors) {
  //     setCurrentStep(TOTAL_STEPS - 1)
  //   }
  // }, [paymentRequestState])

  const plan4 = !is5Order && paymentState.paymentInfo?.plan
  const monthlyPaymentState = plan4
    ? {
        ...paymentState,
        monthlyAddons: [
          {
            code: plan4.planCode,
            name: plan4.planName,
            currency: {
              unitAmount: plan4.currency?.amount,
              currency: paymentState.paymentInfo.curr,
            },
            quantity: 1,
            prodType: 'plan',
          },
          ...(paymentState.monthlyAddons ?? []),
        ],
      }
    : paymentState

  return (
    <>
      <MainMobileContainer>
        {isLoading ? (
          <SkeletonLoader width="100%" height="95vh" />
        ) : (
          <>
            {paymentState?.paymentInfo?.flow === 'upgrade' && (
              <div>
                <BillingNoticeModal
                  setIsBillingNoticeDisplayed={setIsBillingNoticeDisplayed}
                  calledFromPaymentLink={true}
                  isMobileView={true}
                />
              </div>
            )}
            {currentStep === 1 && (
              <div
                style={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                  minHeight: 0,
                }}
              >
                <div style={{flexShrink: 0, paddingInline: '10px'}}>
                  <GradientTabs
                    activeTab={activeTab}
                    onChange={setActiveTab}
                    variant="payment"
                  >
                    <GradientTab id="today">
                      <div className="label">
                        <p
                          className={`tab-label-title${
                            activeTab === 'today' ? ' active' : ''
                          }`}
                        >
                          Due Today{' '}
                          <span>
                            (
                            {
                              (todayItems ?? []).filter(
                                i => i.code !== '247support-m2m',
                              ).length
                            }{' '}
                            Items)
                          </span>
                        </p>
                      </div>
                      <p
                        className={`tab-price${
                          activeTab === 'today' ? ' active' : ''
                        }`}
                      >
                        {formatPrice(todayTotal, 1, '', country)}{' '}
                        {paymentState.calculatedTaxes === null &&
                          !isAusNZ &&
                          ' + Tax'}
                      </p>
                    </GradientTab>
                    <GradientTab id="monthly">
                      <div className="label blue">
                        <p
                          className={`tab-label-title${
                            activeTab === 'monthly' ? ' active' : ''
                          }`}
                        >
                          {summaryMonthlyLabel}{' '}
                          <span>
                            (
                            {
                              (summaryMonthlyAddons ?? []).filter(
                                i => i.code !== '247support-m2m',
                              ).length
                            }{' '}
                            Items)
                          </span>
                        </p>
                      </div>
                      <p
                        className={`tab-price${
                          activeTab === 'monthly' ? ' active' : ''
                        }`}
                      >
                        {isAusNZ
                          ? formatPrice(monthlyTabAmount, 1, '', country)
                          : `${formatPrice(
                              monthlyTabAmount,
                              1,
                              '',
                              country,
                            )} + Tax`}
                        {(!isAusNZ || isAu) && (
                          <span style={{color: '#FF5000'}}>*</span>
                        )}
                      </p>
                    </GradientTab>
                  </GradientTabs>
                </div>
                <div
                  className="payment-form-scroll"
                  style={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '10px',
                    background: '#DDE1EA',
                    borderRadius: '10px',
                    boxShadow: '0px 0px 22px 0px #00000040 inset',
                  }}
                >
                  {activeTab === 'monthly' ? (
                    <CCDesktopMonthlySummary
                      getProducts={getProducts}
                      paymentState={monthlyPaymentState}
                      isAusNZ={isAusNZ}
                      isAu={isAu}
                      hasSupportFee={supportFee}
                      supportFee={supportFee}
                      country={country}
                    />
                  ) : (
                    <CCDesktopTodaySummary
                      todayItems={
                        !frontendPreviewPayment || !paymentPreview
                          ? todayItems
                          : getTodayPreviewItems({
                              paymentState,
                              todayItems,
                              is5Order,
                            })
                      }
                      getProducts={getProducts}
                      isAusNZ={isAusNZ}
                      hasSupportFee={hasSupportFee}
                      paymentState={paymentState}
                      supportFee={supportFee}
                      totalNoTaxes={totalNoTaxes}
                      couponDiscountAmount={couponDiscountAmount}
                      country={country}
                    />
                  )}
                </div>
              </div>
            )}
            {hasEnteredStep2 && (
              <div
                style={{
                  display:
                    currentStep >= 2 && currentStep < 5 ? 'contents' : 'none',
                }}
              >
                {paymentMethods.length > 1 && (
                  <div
                    style={{
                      flexShrink: 0,
                      padding: '10px 8px 8px',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <p
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: '12px',
                        color: '#808080',
                        marginBottom: '0px',
                      }}
                    >
                      Select
                    </p>
                    <p
                      style={{
                        fontFamily: 'Open Sans',
                        fontSize: '16px',
                        fontWeight: 700,
                        color: '#231F20',
                        marginBottom: '10px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Payment Method
                    </p>
                    <div
                      style={{
                        width: '95%',
                        alignSelf: 'center',
                      }}
                    >
                      <PaymentMethod
                        paymentMethod={paymentState.paymentMethod}
                        handleChangePaymentMethod={async method => {
                          setIsPaymentMethodLoading(true)
                          await handleChangePaymentMethod(method)
                          setIsPaymentMethodLoading(false)
                        }}
                        paymentMethods={paymentMethods}
                        isDesktop={true}
                        isLoading={isPaymentMethodLoading}
                        showMethodIcons={false}
                      />
                    </div>
                  </div>
                )}

                <div
                  className="payment-form-scroll"
                  style={{
                    flex: 1,
                    minHeight: 0,
                    overflowY: 'auto',
                    padding: '10px',
                    background: '#DDE1EA',
                    borderRadius: '10px 10px 0 0',
                    boxShadow: 'inset 0 10px 15px -10px #00000040',
                  }}
                >
                  {paymentState?.paymentMethod?.value === 'ach' &&
                    (!paymentState?.paymentInfo?.isInvoiceBilled || isAusNZ) &&
                    currentStep === 2 && (
                      <div
                        style={{
                          border: '1px solid #FBBD23',
                          backgroundColor: '#FEFCE8',
                          borderRadius: '5px 5px 5px 5px',
                          padding: '5px 10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '10px',
                          fontFamily: 'Open Sans',
                          fontWeight: 700,
                          fontSize: '10px',
                          lineHeight: '20px',
                          textAlign: 'center',
                          color: '#4D4D4D',
                          margin: '-10px -10px 8px',
                        }}
                      >
                        <img
                          src={achWarningIcon}
                          alt=""
                          style={{width: '19px', height: '19px', flexShrink: 0}}
                        />
                        Note: A monthly discount will be applied. Check your
                        invoice for details.
                      </div>
                    )}

                  {paymentState?.paymentMethod?.value === 'card' &&
                    (!paymentState?.paymentInfo?.isInvoiceBilled ||
                      isAusNZ) && (
                      <div
                        style={{
                          display:
                            currentStep === 2 || currentStep === 3
                              ? 'contents'
                              : 'none',
                        }}
                      >
                        <StepContainer
                          title=""
                          nextStep={nextStep}
                          showContinueButton={false}
                        >
                          <div>
                            <PaymentForm
                              calculateTaxes={calculateTaxes}
                              calculatingTaxes={calculatingTaxes}
                              setCalculatingTaxes={setCalculatingTaxes}
                              showFirstSection={currentStep === 2}
                              showSecondSection={currentStep === 3}
                              nextStep={nextStep}
                              businessAddress={
                                paymentState?.paymentInfo?.businessAddress
                              }
                              setName={setName}
                              setCurrentStep={setCurrentStep}
                              country={paymentState.paymentInfo.country}
                              bizphone={
                                paymentState.paymentInfo?.businessAddress?.phone
                              }
                              paymentRequestState={paymentRequestState}
                              setPaymentRequestState={setPaymentRequestState}
                              disclaimerText={subscriptionDisclaimerText}
                            />
                          </div>
                        </StepContainer>
                      </div>
                    )}

                  {paymentState?.paymentMethod?.value ===
                    paymentMethods[0].value &&
                    !!paymentState?.paymentInfo?.isInvoiceBilled && (
                      <div
                        style={{
                          display: currentStep === 2 ? 'contents' : 'none',
                        }}
                      >
                        <StepContainer title="" showContinueButton={false}>
                          <InvoicePaymentForm
                            calculateTaxes={calculateTaxes}
                            calculatingTaxes={calculatingTaxes}
                            setCalculatingTaxes={setCalculatingTaxes}
                            handleCompleteOrder={handleSubmitOrder}
                            updateParentAddress={updateParentAddress}
                            businessAddress={
                              paymentState.paymentInfo?.businessAddress
                            }
                            country={paymentState?.paymentInfo?.country}
                            setName={setName}
                            setIsAddressUpdated={setIsAddressUpdated}
                            bizphone={
                              paymentState.paymentInfo?.businessAddress?.phone
                            }
                            isAddressUpdated={isAddressUpdated}
                            uuid={uuid}
                            setAddressInformation={setAddressInformation}
                            addressInformation={addressInformation}
                            isMobile={true}
                            disclaimerText={subscriptionDisclaimerText}
                            is5Order={is5Order}
                          />
                        </StepContainer>
                      </div>
                    )}

                  {paymentState?.paymentMethod?.value === 'ach' &&
                    (!paymentState?.paymentInfo?.isInvoiceBilled ||
                      isAusNZ) && (
                      <div
                        style={{
                          display:
                            currentStep === 2 || currentStep === 3
                              ? 'contents'
                              : 'none',
                        }}
                      >
                        <StepContainer title="" showContinueButton={false}>
                          <div style={{paddingTop: '10px', width: '100%'}}>
                            <AchPaymentForm
                              calculateTaxes={calculateTaxes}
                              calculatingTaxes={calculatingTaxes}
                              setCalculatingTaxes={setCalculatingTaxes}
                              showFirstSection={currentStep === 2}
                              showSecondSection={currentStep === 3}
                              nextStep={nextStep}
                              businessAddress={
                                paymentState?.paymentInfo?.businessAddress
                              }
                              setName={setName}
                              country={paymentState.paymentInfo.country}
                              bizphone={
                                paymentState.paymentInfo?.businessAddress?.phone
                              }
                              setCurrentStep={setCurrentStep}
                              disclaimerText={subscriptionDisclaimerText}
                            />
                          </div>
                        </StepContainer>
                      </div>
                    )}

                  {paymentState?.paymentMethod?.value === 'becs' && (
                    <StepContainer title="" showContinueButton={false}>
                      <div
                        style={{
                          paddingTop: '10px',
                          width: '100%',
                          display:
                            (!paymentState?.paymentInfo?.isInvoiceBilled ||
                              isAusNZ) &&
                            currentStep === 2
                              ? 'block'
                              : 'none',
                        }}
                      >
                        <BecsPaymentForm
                          calculateTaxes={calculateTaxes}
                          calculatingTaxes={calculatingTaxes}
                          setCalculatingTaxes={setCalculatingTaxes}
                          showFirstSection={currentStep === 2}
                          showSecondSection={currentStep === 3}
                          nextStep={nextStep}
                          businessAddress={
                            paymentState?.paymentInfo?.businessAddress
                          }
                          setName={setName}
                          country={paymentState.paymentInfo.country}
                          bizphone={
                            paymentState.paymentInfo?.businessAddress?.phone
                          }
                          setCurrentStep={setCurrentStep}
                          disclaimerText={subscriptionDisclaimerText}
                        />
                      </div>
                    </StepContainer>
                  )}
                </div>

                {currentStep === 2 && (
                  <div
                    style={{
                      flexShrink: 0,
                      padding: '8px 8px 16px',
                      background: '#DDE1EA',
                      borderRadius: '0 0 10px 10px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '10px 12px',
                        borderRadius: '8px',
                        boxShadow: '0 0 0 2px #5378FC',
                        background: '#ffffff',
                      }}
                    >
                      <span
                        onClick={
                          isAgreeCheckboxDisabled
                            ? () =>
                                toast.warn(
                                  'Please complete your payment information.',
                                )
                            : undefined
                        }
                        style={{
                          display: 'flex',
                          cursor: isAgreeCheckboxDisabled
                            ? 'not-allowed'
                            : 'auto',
                          flexShrink: 0,
                        }}
                      >
                        <input
                          type="checkbox"
                          id="terms"
                          name="terms"
                          title={
                            isAgreeCheckboxDisabled
                              ? 'Please complete your payment information.'
                              : undefined
                          }
                          checked={checkBoxesValues.agreedTerms}
                          disabled={isAgreeCheckboxDisabled}
                          onChange={e => {
                            setCheckBoxesValues({
                              ...checkBoxesValues,
                              agreedTerms: e.target.checked,
                            })
                          }}
                          style={{
                            cursor: isAgreeCheckboxDisabled
                              ? 'not-allowed'
                              : 'pointer',
                            width: '16px',
                            height: '16px',
                            accentColor: '#5378FC',
                            pointerEvents: isAgreeCheckboxDisabled
                              ? 'none'
                              : 'auto',
                          }}
                        />
                      </span>
                      <label
                        htmlFor="terms"
                        className="card-number-helper-text"
                        onClick={
                          isAgreeCheckboxDisabled
                            ? () =>
                                toast.warn(
                                  'Please complete your payment information.',
                                )
                            : undefined
                        }
                        style={{
                          marginTop: 0,
                          cursor: isAgreeCheckboxDisabled
                            ? 'not-allowed'
                            : 'pointer',
                          fontWeight: 700,
                          fontSize: '13px',
                        }}
                      >
                        By checking this box, you agree to our{' '}
                        <a
                          target="_blank"
                          href="https://corporate.thryv.com/terms/"
                          rel="noreferrer"
                          style={{fontWeight: 700, color: '#5378FC'}}
                        >
                          Terms &amp; Conditions
                        </a>
                        <span style={{color: '#FF5000'}}> *</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            )}
            {currentStep === 5 && (
              <div className="d-flex flex-column align-items-center">
                <Icon
                  style={{marginBottom: '25px'}}
                  type="solid"
                  variant="circleCheck"
                  color={is5Order ? '#16A085' : '#5cb95c'}
                  width="48px"
                  height="48px"
                />
                <ParagraphText
                  variant="lg"
                  style={{
                    color: is5Order ? '#16A085' : '',
                    textAlign: is5Order ? 'center' : 'left',
                  }}
                >
                  <strong>
                    Thank you {name}, your payment information is successfully
                    updated!
                  </strong>
                </ParagraphText>
                <ParagraphText variant="lg">
                  We will use this information to bill your Thryv subscriptions
                  each month.
                </ParagraphText>
                <ParagraphText variant="lg">
                  You can update your billing information through the My Account
                  page.
                </ParagraphText>
                <ParagraphText variant="lg">
                  <strong>Thank you for purchasing Thryv!</strong>
                </ParagraphText>
              </div>
            )}
          </>
        )}
      </MainMobileContainer>
      {(currentStep === 1 || currentStep === 2) && (
        <div style={{padding: '10px 0'}}>
          {currentStep === 1 && activeTab === 'monthly' && (
            <p
              style={{
                fontSize: '14px',
                color: '#ffffff',
                fontWeight: 700,
                margin: '0 0 4px 0',
              }}
            >
              {isAu
                ? '*Excludes fees and incentives'
                : '*Excludes taxes, fees, and incentives'}
            </p>
          )}
          <button
            type="button"
            onClick={() => {
              if (currentStep === 2) {
                if (!checkBoxesValues.agreedTerms) {
                  toast.warn(
                    'Please agree to the Terms and Conditions to continue.',
                  )
                  return
                }
                handleSubmitOrder()
              } else {
                setCurrentStep(2)
                setHasEnteredStep2(true)
              }
            }}
            disabled={currentStep === 2 && calculatingTaxes}
            style={{
              width: '100%',
              height: '42px',
              backgroundColor:
                currentStep === 2 && !checkBoxesValues.agreedTerms
                  ? '#BFBFBF'
                  : '#FF5000',
              color: '#ffffff',
              border: 'none',
              borderRadius: '10px',
              padding: '10px 20px',
              fontSize: '16px',
              fontWeight: 700,
              fontFamily: 'Open Sans',
              lineHeight: '100%',
              letterSpacing: '0%',
              cursor:
                currentStep === 2 && calculatingTaxes
                  ? 'not-allowed'
                  : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
            }}
          >
            <svg
              width="18"
              height="15"
              viewBox="0 0 18 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.4019 14.4511C11.4039 14.4491 11.4059 14.4471 11.408 14.445L17.709 8.1522C17.7588 8.10221 17.8029 8.04696 17.8408 7.98746L17.9397 7.80626L17.9809 7.68271L17.9809 7.5921C18.0064 7.45326 18.0064 7.3109 17.9809 7.17202L17.9809 7.08967L17.9809 6.99083L17.9067 6.85079C17.8643 6.77276 17.8117 6.70071 17.7502 6.63662L11.408 0.319083C10.9883 -0.103963 10.3051 -0.106704 9.88203 0.312983C9.87998 0.314991 9.87797 0.317037 9.87593 0.319083C9.46906 0.745526 9.46906 1.41641 9.87593 1.84289L13.6319 5.60706C13.7911 5.76945 13.7885 6.03022 13.6261 6.18945C13.5506 6.26354 13.4494 6.3057 13.3436 6.30717L1.07911 6.30717C0.483169 6.30713 4.92943e-05 6.79017 9.21389e-06 7.38611C-2.89591e-05 7.98205 0.483015 8.46514 1.07895 8.46521L1.07911 8.46521L13.3436 8.46521C13.571 8.46842 13.7528 8.65537 13.7496 8.88278C13.7481 8.98857 13.706 9.08976 13.6319 9.16532L9.87593 12.913C9.46381 13.3406 9.46381 14.0175 9.87593 14.4451C10.2956 14.8681 10.9788 14.8709 11.4019 14.4511Z"
                fill="white"
              />
            </svg>
            {currentStep === 2 ? (
              <>
                <span style={{fontWeight: 400}}>PAY NOW&nbsp;</span>
                <span>
                  {formatPrice(todayTotal, 1, '', country)}
                  {paymentState.calculatedTaxes === null &&
                    !isAusNZ &&
                    !(
                      frontendPreviewPayment &&
                      paymentState.paymentInfo?.paymentPreview?.tax > 0
                    ) &&
                    ' + Tax'}
                </span>
              </>
            ) : (
              'PROCEED TO PAY'
            )}
          </button>
        </div>
      )}
    </>
  )
}

export default MobileLayout
